import EditorialSection from 'components/EditorialSection';
import Section from 'components/Section';
import { forwardRef } from 'react';
import './index.css';

const Experience = forwardRef(({ id, sectionRef, resumeExperience }, ref) => {
  if (!resumeExperience?.length) return null;

  return (
    <Section
      className="experience"
      as="section"
      id={id}
      ref={sectionRef || ref}
      aria-labelledby={`${id}-title`}
      tabIndex={-1}
    >
      <EditorialSection
        index={2}
        eyebrow="Experience"
        title="Where I've worked"
        headingId={`${id}-title`}
        meta={`${resumeExperience.length} ROLES`}
      />
      <ol className="experience__timeline">
        {resumeExperience.map((work, i) => (
          <li className="experience__entry" key={`${work.company}-${i}`}>
            <div className="experience__years" aria-label="Period">
              {work.years}
            </div>
            <div className="experience__content">
              <h3 className="experience__company">{work.company}</h3>
              <div className="experience__role">{work.title}</div>
              <p className="experience__description">{work.description}</p>
              <ul className="experience__tech">
                {work.technologies.map(tech => (
                  <li className="experience__chip" key={tech}>{tech}</li>
                ))}
              </ul>
            </div>
          </li>
        ))}
      </ol>
    </Section>
  );
});

export default Experience;
